import { useQuickSubmit } from '@gonfalon/dom/useQuickSubmit';
import type { TextFieldProps } from '@launchpad-ui/components';
import { TextArea, TextField } from '@launchpad-ui/components';

type CommentAreaProps = TextFieldProps & {
  placeholder?: string;
  rows?: number;
  required?: boolean;
  disabled?: boolean;
};

const CommentArea = ({ required, placeholder = '', rows = 4, disabled, ...additionalProps }: CommentAreaProps) => {
  const quicksubmit = useQuickSubmit();

  return (
    <TextField
      id={COMMENT_AREA_ID}
      name={COMMENT_AREA_ID}
      isRequired={required}
      isDisabled={disabled}
      {...additionalProps}
      {...quicksubmit.props}
    >
      <TextArea placeholder={placeholder} rows={rows} />
    </TextField>
  );
};

export const COMMENT_AREA_ID = 'comment';

/* eslint-disable import/no-default-export */
export default CommentArea;
